export default "__VITE_ASSET__D$ydddXT__"